<template>
    <div class="event-card mb-4">
         <div class="row">
            <div class="image order-1">
                <div class="image-wrapper" v-imagekit.background="{ image: event.picture, transform: 'w-150,h-180,fo-auto' }">
                    <i class="icons8-image" v-if="!event.picture"></i>
                    <!-- <img v-if="event.picture" :src="event.picture" :alt="event.name" class="sr-only"/> -->
                    <div class="date">
                        <time class="day" :datetime="event.start">{{ event.start | moment("DD")  }}</time>&nbsp;
                        <time class="month" :datetime="event.start">{{ event.start | moment("MMM")  }}</time>
                    </div>
                </div>
            </div>

           <div class="content order-2">
               <div class="row">
                    <div class="date order-1">
                        <time class="day" :datetime="event.start">{{ event.start | moment("DD")  }}</time>&nbsp;
                        <time class="month" :datetime="event.start">{{ event.start | moment("MMM")  }}</time>
                    </div>

                    <!-- <div class="community order-md-1 order-lg-1" v-if="event.networks[0]">
                        <p>
                            <svg xmlns="http://www.w3.org/2000/svg" width="13.149" height="13.15" viewBox="0 0 13.149 13.15"><path class="a" d="M9.575,3A6.575,6.575,0,1,0,16.15,9.575,6.577,6.577,0,0,0,9.575,3ZM6.945,13.191a1.644,1.644,0,1,1,1.644-1.644A1.644,1.644,0,0,1,6.945,13.191Zm.986-6.246A1.644,1.644,0,1,1,9.575,8.589,1.644,1.644,0,0,1,7.931,6.945ZM12.2,13.191a1.644,1.644,0,1,1,1.644-1.644A1.644,1.644,0,0,1,12.2,13.191Z" transform="translate(-3 -3)"/></svg>
                            <strong>{{ event.networks[0].network.name | truncate(15,'...') }}</strong>
                        </p>
                    </div> -->

                    <div class="city order-2 order-md-2 order-lg-3">
                        <p>
                            <svg xmlns="http://www.w3.org/2000/svg" width="12.868" height="15.533" viewBox="0 0 12.868 15.533"><g transform="translate(-5.885 -1.104)"><path class="a" d="M6.434,15.533h0L1.884,10.984a6.435,6.435,0,0,1,9.1-9.1,6.434,6.434,0,0,1,0,9.1L6.435,15.533Zm0-12.153A2.987,2.987,0,1,0,9.421,6.369,2.991,2.991,0,0,0,6.433,3.381Z" transform="translate(5.885 1.104)"/></g></svg>
                            {{ event.city ? event.city.name : "Online"}}
                        </p>
                    </div>

                    <div class="price order-5 order-md-3 order-lg-4">
                        <p v-if="event.price">{{ event.currency }}&nbsp;{{ event.price }}</p>
                        <p v-else>Free</p>
                    </div>

                    <div class="organiser order-4 order-md-4 order-lg-5">
                        <p v-if="event.company">
                            <span class="label-organiser">Organized</span> By:&nbsp;
                            <span><strong>{{ event.company.name }}</strong></span>
                        </p>
                    </div>

                    <div class="description order-3 order-md-5 order-lg-2">
                        <h3 class="title" v-router-link="{ name: 'EventDetail', params: { id: event.id }}">
                            {{ event.name | truncate(71,'...') }}
                        </h3>
                        <hr />
                        <div class="tag">
                            <span class="badge" v-for="(tag, index) in tags" :key="index">{{ tag }}</span>
                        </div>
                    </div>
               </div>
           </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'events-card',

    props: {
        event: {
            type: Object,
            default() {
                return {};
            }
        },
    },

    computed: {
        tags() {
            return this.event.tags;
        }
    },
}
</script>

<style lang="scss" scoped>
    .event-card {
        background-color: #ffffff;
        padding: 10px 15px 14px;
        @include media-breakpoint-up(md) {
            padding-top: 0;
            padding-bottom: 0;
        }
    }

    p {
        margin-bottom: 0;
    }

    svg {
        margin-right: 5px;
        margin-bottom: 3px;
        path {
            fill: $grey;
        }
    }

    .image {
        display: none;
        @include media-breakpoint-up(md) {
            display: block;
            @include make-col-ready(0);
            @include make-col(2.2);
        }

        @include media-breakpoint-up(lg) {
            @include make-col(2);
        }

        @include media-breakpoint-up(xl) {
            @include make-col(1.6);
        }

        .image-wrapper {
            position: relative;
            background-size: cover;
            background-position: top center;
            background-repeat: no-repeat;
            background-color: rgba(198, 200, 216, 0.88);
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: flex-end;
            min-height: 175px;
            width: 100%;
            height: 100%;
            overflow: hidden;
            color: #ffffff;

            &:before {
                content: '';
                width: 100%;
                height: 100%;
                z-index: 0;
                position: absolute;
                left: 0;
                bottom: 0;
                background-color: rgba(0, 1, 18, 0.16);
                background: -moz-linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(0,1,18,1) 100%);
                background: -webkit-linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(0,1,18,1) 100%);
                background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(0,1,18,1) 100%);
                filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#ffffff",endColorstr="#000112",GradientType=1);
            }
        }

        .date {
            position: relative;
            text-transform: uppercase;
            font-weight: 700;
            margin-bottom: 10px;

            .day {
                font-size: 26px;
                letter-spacing: 1.3px;
            }

            .month {
                font-size: 16px;
                letter-spacing: 0.8px;
            }
        }
    }

    .content {
        font-size: 16px;
        color: $grey;
        @include make-col-ready();
        @include media-breakpoint-up(md) {
            @include make-col(9.8);
            padding-top: 20px;
            padding-bottom: 20px;
            padding-left: 25px;
        }
        @include media-breakpoint-up(lg) {
            @include make-col(10);
        }

        @include media-breakpoint-up(xl) {
            @include make-col(10.4);
        }

        .date {
            color: $primary;
            @include make-col-ready();
            @include make-col(4);
            @include media-breakpoint-up(md) {
                display: none
            }
        }

        .community {
            @include make-col-ready();
            display: none;
            @include media-breakpoint-up(md) {
                display: flex;
                font-size: 14px;
                @include make-col-ready();
                @include make-col(3.6);
            }
            @include media-breakpoint-up(lg) {
                @include make-col(12);
            }
        }

        .city {
            @include make-col-ready();
            @include make-col(8);
            text-align: right;
            @include media-breakpoint-up(md) {
                text-align: left;
                @include make-col-ready();
                @include make-col(2.8);
            }
            @include media-breakpoint-up(lg) {
                @include make-col(2);
                align-self: center;
            }
        }

        .price {
            @include make-col-ready();
            @include make-col-auto();
            @include media-breakpoint-up(md) {
                @include make-col-ready();
                @include make-col(2.2);
            }
            @include media-breakpoint-up(lg) {
                @include make-col(2);
                align-self: center;
            }
        }

        .organiser {
            @include make-col-ready();
            @include make-col-auto();
            @include media-breakpoint-up(md) {
                @include make-col-ready();
                @include make-col(3.4);
            }
            @include media-breakpoint-up(lg) {
                @include make-col(2.2);
                align-self: center;
            }

            @include media-breakpoint-up(xl) {
                @include make-col(2);
            }

            .label-organiser {
                display: none;
                @include media-breakpoint-up(lg) {
                    display: inline;
                }
            }
            span {
                @include media-breakpoint-up(lg) {
                    display: block;
                }
            }
        }

        .description {
            color: $secondary;
            font-size: 18px;
            @include make-col-ready();
            @include make-col(12);
            @include media-breakpoint-up(md) {
                @include make-col-ready();
                @include make-col(12);
            }

            @include media-breakpoint-up(lg) {
                @include make-col(5.8);
                align-self: center;
            }

            @include media-breakpoint-up(xl) {
                @include make-col(6);
            }

            h3 {
                margin-top: 10px;
                cursor: pointer;
                font-weight: 700;
                line-height: 22px;

                @include media-breakpoint-up(md) {
                    font-size: 22px;
                    line-height: 27px;
                    margin-bottom: 25px;
                }

                &:hover {
                    color: $primary;
                }
            }

            hr {
                display: block;
                @include media-breakpoint-up(md) {
                    display: none;
                }
            }

            .tag {
               display: none;
                @include media-breakpoint-up(md) {
                    display: block;
                }
            }
        }
    }
</style>
